const req = require.context('.', false, /^((?!index).)*\.[j|t]sx?$/)

req.keys().forEach((key) => {
  const containerName = key.replace(/^\.\/([^.]+)\.[j|t]sx?$/, '$1')
  module.exports[containerName] = req(key).default
})
